module.exports = __webpack_public_path__ + "static/media/elephant_outline-min.f5dc8802.jpg";